import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/cafe")({
  beforeLoad: ({ location }) => {
    if (location.pathname === "/cafe") {
      throw redirect({ to: "/cafe/dashboard", replace: true });
    }
  },
  component: CafeLayout,
});

function CafeLayout() {
  return <Outlet />;
}
